module.exports = __webpack_public_path__ + "static/media/item_29_6.28003677.png";